import { Duration } from '../../../animations/component-lib.esm.js';
import { colors } from '../../component-lib.esm.js';
const openSansFont = `"Open Sans", sans-serif`;
const visbyFont = `"Visby CF", "Open Sans", sans-serif`;
const campsiteTheme = {
  name: 'campsite',
  colors: {
    primary: colors.green2,
    secondary: colors.orange,
    bg: colors.white,
    onPrimary: colors.white,
    onSecondary: colors.white,
    onBg: colors.blackPure,
    placeholder: colors.grayDark,
    focus: colors.yellow,
    anchor: colors.blueDark,
    error: colors.red,
    success: colors.greenSuccess,
    info: colors.yellow,
    lightBlue: colors.blueLight,
    darkGreen: colors.greenDark,
    lightGreen: colors.greenLight,
    orange: colors.orange,
    yellow: colors.yellow,
    black: colors.blackPure,
    gray100: '#f4f4f4',
    gray200: '#E0E0E0',
    gray300: '#C8C8C8',
    gray400: '#888',
    gray500: '#707070',
    gray600: '#505050',
    gray700: '#383838',
    gray800: '#282828',
    gray900: '#101010'
  },
  dataColors: [colors.green, colors.orange, colors.blueLight, colors.yellow, colors.greenDark, colors.blueDark, colors.greenLight],
  font: {
    bodyFamily: openSansFont,
    headerFamily: visbyFont,
    headerWeight: '700',
    headerTextTransform: 'none',
    headerLetterSpacing: '0.015em',
    buttonFamily: openSansFont,
    inputFamily: openSansFont
  },
  button: {
    fontWeight: '500',
    textTransform: 'none',
    letterSpacing: '0'
  },
  transitionSpeed: Duration.SHORT + 'ms',
  // In rem
  borderRadius: {
    standard: 5,
    large: 5,
    circular: 5,
    min: 1
  },
  zIndex: {
    drawerOverlay: 9996,
    drawer: 9997,
    modal: 9998,
    popup: 9999
  },
  // In px
  breakpoints: {
    xs: 0,
    sm: 544,
    md: 768,
    lg: 992,
    xl: 1200
  },
  // In rem
  sizes: {
    xsmall: 0.5,
    small: 1,
    medium: 1.6,
    large: 2,
    xlarge: 2.5,
    xxlarge: 3
  },
  profile: {
    bgColor: colors.grayLight,
    bgGradientColor: null,
    bgGradientDirection: '180deg',
    btnMarginBottom: '12px',
    textColor: colors.black,
    fontFamily: openSansFont,
    imageBorderColor: colors.grayLight,
    // button
    btnBgColor: colors.green,
    btnColor: colors.white,
    btnBoxShadow: 'none',
    btnBoxShadowColor: 'transparent',
    btnBoxShadowSize: '0px',
    btnShadowStyle: null,
    btnBorderWidth: '2px',
    btnBorderColor: colors.green,
    btnBorderRadius: '4px',
    btnFontFamily: openSansFont,
    btnFontWeight: '700',
    btnStyle: 'filled',
    // carousel
    carouselBgColor: colors.grayLight,
    carouselLoaderColor: colors.grayDark,
    // divider
    dividerColor: colors.blackPure,
    // title
    titleColor: colors.black,
    titleFontFamily: openSansFont,
    titleFontWeight: '700',
    // social accounts
    socialColor: colors.green
  }
};
export { campsiteTheme };